import { render, staticRenderFns } from "./GrButtonNew.vue?vue&type=template&id=7318cf62&scoped=true&"
import script from "./GrButtonNew.vue?vue&type=script&lang=ts&"
export * from "./GrButtonNew.vue?vue&type=script&lang=ts&"
import style0 from "./GrButtonNew.vue?vue&type=style&index=0&id=7318cf62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318cf62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
